module.exports = __webpack_public_path__ + "media/img/favicon-96x96-13cdc4f2e20a0cb497a8bc7c05e4605c.png";